var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotCompletedTask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 6,
    fill: "#C4D572"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4333_51707)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1017 14.402L11.6245 32.8135C11.4085 33.2072 11.2942 33.6537 11.293 34.1084C11.2918 34.5631 11.4037 35.0103 11.6176 35.4053C11.8315 35.8003 12.14 36.1295 12.5123 36.3601C12.8846 36.5908 13.3078 36.7147 13.7397 36.7197H34.6942C35.1261 36.7147 35.5493 36.5908 35.9216 36.3601C36.2939 36.1295 36.6024 35.8003 36.8163 35.4053C37.0302 35.0103 37.1421 34.5631 37.1409 34.1084C37.1397 33.6537 37.0254 33.2072 36.8094 32.8135L26.3322 14.402C26.1117 14.0193 25.8012 13.7029 25.4307 13.4834C25.0602 13.2638 24.6421 13.1484 24.2169 13.1484C23.7918 13.1484 23.3737 13.2638 23.0032 13.4834C22.6327 13.7029 22.3222 14.0193 22.1017 14.402Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2188 21.0938V26.3021",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2188 31.5117H24.2311",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4333_51707"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.6875,
    height: 31.25,
    fill: "white",
    transform: "translate(9.375 9.375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotCompletedTask);
export default __webpack_public_path__ + "static/media/notCompletedTask.be2c69639a2b4469fa4f2093329fadea.svg";
export { ForwardRef as ReactComponent };